module.exports = __webpack_public_path__ + "static/1-6fcaaa57fc8434334f794544ab5fc682.jpg";